import React from 'react';
import styled from 'styled-components';
import { Wrapper } from '../shared/commonStyles';
import Title from '../title/Title';
import ProductCard from '../card/ProductCard';
import Logo from '../logo/Logo';
import ScrollToTopButton from '../button/ScrollToTopButton';

import Image1 from '../../assets/image/produce_cafe/dressy_room_tea.png'
import Image2 from '../../assets/image/produce_cafe/dressy_cafe.png'

const ProductCafeWrapper = styled.section`
  padding-bottom: 20px;
`;

const SectionProduceCafe = () => {
    const buttonText = '公式HP'

    // DRESSY ROOM＆Tea（鎌倉）
    const description1_1 = "お花とドレスと紅茶のお店\n女の子の日常に、きらめく魔法空間を。"
    const description1_2 = "日常で気軽に利用できる「煌めく魔法の場所」という\n新しい選択肢を増やしたい。\nウェディングドレスは特別な時だけのものではなく、\nもっと身近に、もっと気軽に、\n体感できる空間となっています。"

    const descriptionArray1 = [
        description1_1,
        description1_2,
    ]

    // DRESSY CAFE（名古屋）
    const description2_1 = "きらめく魔法にかけられて…\nウェディングのテーマパーク体験型カフェ    "
    const description2_2 = "SNS映えする、思わず写真を撮りたくなる仕掛けがたくさん。\n色を使わないカフェの内装は、カラフルな紅茶やお花、\nウェディングドレスが煌めき、魔法にかかります。"

    const descriptionArray2 = [
        description2_1,
        description2_2,
    ]

    return (
      <Wrapper id="produce-cafe">
        <ProductCafeWrapper>
            <Title 
                title={"PRODUCE CAFE"}
                subTitle={"プロデュースカフェ"}    
            />
            <ProductCard 
                title={"DRESSY CAFE KAMAKURA（鎌倉）"}
                image={Image1}
                description={descriptionArray1}
                url={"https://dressyroom-tea.pla-cole.wedding/"}
                buttonText={buttonText}
            />
            <ProductCard 
                title={"DRESSY CAFE（名古屋）"}
                image={Image2}
                description={descriptionArray2}
                url={"https://dressycafe-nagoya.pla-cole.wedding/"}
                buttonText={buttonText}
            />
            <Logo />
            <ScrollToTopButton />
        </ProductCafeWrapper>
      </Wrapper>
    );
  };
  
export default SectionProduceCafe;
  